import React from 'react';
import styled from 'styled-components';
import { Body1, Body5, Container } from '@ui';

// A centred state panel: one bold line, one low-contrast line, an optional action. The vault's
// empty-state shape, used here for the tenant gates ("Not set up", "Switched off") and for the
// lists' empty and failed states.

const StateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: ${({ $compact }) => ($compact ? '32px 16px' : '64px 16px')};
`;

export const GateNotice = ({ title, body, children, compact = false }) => (
  <StateWrapper $compact={compact} role="status">
    <Body1 bold>{title}</Body1>
    {body && (
      <Container top={8}>
        <Body5 isLowContrast>{body}</Body5>
      </Container>
    )}
    {children && <Container top={16}>{children}</Container>}
  </StateWrapper>
);
